module.exports = __webpack_public_path__ + "static/img/mf_slider1.65c56b3.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/mf_slider1.webp
// module id = 2d9R
// module chunks = 5